import kotlinx.browser.document
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLElement

class CheckEmailPage(
    private val email: String,
    private val apiService: ApiService,
    private val onLoginClick: () -> Unit,
) {
    fun render(): HTMLElement {
        val container = document.createElement("div") as HTMLElement
        container.style.cssText = """
            display: flex; flex-direction: column; align-items: center; justify-content: center;
            min-height: 100dvh; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            background: linear-gradient(180deg, #0a0a0a 0%, #141418 100%); padding: 20px;
        """
        container.innerHTML = buildCard(statusMessage = null)
        attachListeners(container)
        return container
    }

    private fun buildCard(statusMessage: String?): String {
        val statusHtml = if (statusMessage != null) """
            <p id="resend-status" style="color: #00d9ff; font-size: 14px; margin: 8px 0 0; text-align: center;">$statusMessage</p>
        """ else """
            <p id="resend-status" style="color: #00d9ff; font-size: 14px; margin: 8px 0 0; text-align: center; display: none;"></p>
        """
        return """
            <div style="
                background: rgba(20, 20, 24, 0.9); border-radius: 16px; padding: 40px 32px;
                box-shadow: 0 8px 32px rgba(0, 217, 255, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.05);
                width: 380px; max-width: 90vw; text-align: center;
            ">
                <div style="font-size: 48px; margin-bottom: 16px;">📧</div>
                <h2 style="color: #fff; margin: 0 0 12px; font-size: 24px;">Check Your Email</h2>
                <p style="color: #999; font-size: 15px; line-height: 1.5; margin: 0 0 8px;">
                    We sent a verification link to:
                </p>
                <p style="color: #00d9ff; font-size: 15px; font-weight: 600; margin: 0 0 20px; word-break: break-all;">
                    $email
                </p>
                <p style="color: #666; font-size: 13px; line-height: 1.5; margin: 0 0 24px;">
                    Click the link in the email to verify your account, then come back here to log in.
                </p>
                <button id="check-email-login-btn" style="
                    width: 100%; padding: 14px; background: linear-gradient(135deg, #00d9ff 0%, #00b8d9 100%);
                    color: #0a0a0a; border: none; border-radius: 8px; font-size: 16px; font-weight: 600;
                    cursor: pointer; box-shadow: 0 4px 12px rgba(0, 217, 255, 0.3); margin-bottom: 12px;
                ">Go to Login</button>
                <button id="check-email-resend-btn" style="
                    width: 100%; padding: 12px; background: transparent;
                    color: #888; border: 1px solid #333; border-radius: 8px; font-size: 14px;
                    cursor: pointer;
                ">Resend Verification Email</button>
                $statusHtml
            </div>
        """
    }

    private fun attachListeners(container: HTMLElement) {
        container.querySelector("#check-email-login-btn")?.addEventListener("click", {
            onLoginClick()
        })

        container.querySelector("#check-email-resend-btn")?.addEventListener("click", {
            val resendBtn = container.querySelector("#check-email-resend-btn") as? HTMLElement
            val statusEl = container.querySelector("#resend-status") as? HTMLElement
            resendBtn?.setAttribute("disabled", "true")
            resendBtn?.asDynamic().style.opacity = "0.5"

            GlobalScope.launch {
                val result = apiService.resendVerification(email)
                if (result.isSuccess) {
                    statusEl?.textContent = "✅ Verification email resent! Check your inbox."
                    statusEl?.asDynamic().style.display = "block"
                } else {
                    statusEl?.textContent = "❌ Failed to resend. Please try again later."
                    statusEl?.asDynamic().style.display = "block"
                    resendBtn?.removeAttribute("disabled")
                    resendBtn?.asDynamic().style.opacity = "1"
                }
            }
        })
    }
}
